import React, { useState, useEffect } from "react";
import * as incpectionAction from "../../../../redux/actions/incpectionAction";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SwInspectionAcknowledgment from "../components/swInspectionAcknowledgment";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { ACCESS_DENIED, SW_VIEW_MAPPING_ACKNOWLEDGMENT, VIEW_MAPPING_ACKNOWLEDGMENT } from "../../../../constant/routeContant";
import Loader from "../../../../library/common/Loader";

const SwInspectionAcknowledgmentContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [clearInspectionAcknowledgement, setClearInspectionAcknowledgement] = useState(false);
  const [checkStatus, setCheckStatus] = useState(1);

  const defaultSubData = {
    type: 9,
  };

  const getInspectionAcknowledgement = useSelector(
    (state) => state.getInspectionAcknowledgement
  );

  const updateSwInspectionAcknowledgement = useSelector(
    (state) => state.updateSwInspectionAcknowledgement
  );

  const showLoader = useSelector(
    (state) =>
      state.getInspectionAcknowledgement?.isLoading ||
      state.updateSwInspectionAcknowledgement?.isLoading
  );

  const getInspectionAcknowledgementData = (data) => {
    dispatch(incpectionAction.getInspectionAcknowledgement(data));
  };

  const viewMapping = (data) => {
    navigate(SW_VIEW_MAPPING_ACKNOWLEDGMENT, {
      state: { acknowledgment: data },
    });
  };

  const onSubmit = (data) => {
    setClearInspectionAcknowledgement(true);
    dispatch(swInspectionAction.updateSwInspectionAcknowledgement(data));
  };

  useEffect(() => {
    getInspectionAcknowledgementData(defaultSubData);
  }, []);

  useEffect(() => {
    if (
      updateSwInspectionAcknowledgement?.status === "SUCCESS" &&
      updateSwInspectionAcknowledgement?.isLoading === false &&
      clearInspectionAcknowledgement
    ) {
      if (checkStatus === 1) {
        toast("Inspection Acknowledgement Added successfully");
      } else if (checkStatus === 2) {
        toast("Inspection Acknowledgement Updated successfully");
      }
      getInspectionAcknowledgementData(defaultSubData);
    }
  }, [updateSwInspectionAcknowledgement]);

  return (
    <>
      {checkPrivileges([12, 120, 121, 4]) ? (
        <>
          {showLoader && <Loader />}
          <SwInspectionAcknowledgment
            getInspectionAcknowledgement={getInspectionAcknowledgement}
            onSubmit={onSubmit}
            updateSwInspectionAcknowledgement={updateSwInspectionAcknowledgement}
            setCheckStatus={setCheckStatus}
            viewMapping={viewMapping}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default SwInspectionAcknowledgmentContainer;